export default __webpack_public_path__ + "static/media/icon3_blue.a90c4dc6.svg";